export default __webpack_public_path__ + "static/media/researchimage.ac818dd3.jpeg";